import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function rewardTypeFilter(value: number) {
  const t = getTranslateNsT("center");

  // NOTE: 0 线下礼品 1 GPU券 2 CPU券 3 通用券 4 青云券
  return t(
    {
      0: "coupon_pages_type_offline",
      1: "coupon_pages_type_gpu",
      2: "coupon_pages_type_cpu",
      3: "coupon_pages_type_general",
      4: "coupon_pages_type_youth",
      6: "coupon_pages_type_gpu_youth",
      8: "coupon_pages_type_8",
    }[value] ?? `coupon_pages_type_${value}`
  );
}
